"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldClientPickerBeVisible = void 0;
/**
 * Determines whether user should be able to see the client picker in the UI.
 * * Internal users should be able to see the client picker (regardless of how many clients)
 * * External users should only be able to see it if they have more than 1 client
 * @function
 * @name shouldClientPickerBeVisible
 * @param appId - The `Client ID` for the Auth0 app.
 * @param metadata - The metadata returned in our authentication details.
 * @returns True or False.
 */
const shouldClientPickerBeVisible = (appId, metadata) => {
    const applications = metadata?.applications;
    const episourceAccess = metadata?.episourceAccess;
    const application = applications?.[appId];
    const numberOfClients = application?.clientIds?.length || 0;
    return Boolean(episourceAccess?.isInternal ||
        (application && applications && numberOfClients > 1));
};
exports.shouldClientPickerBeVisible = shouldClientPickerBeVisible;
